<template>
    <a
        v-if="isAdmin"
        href="/backend"
        class="fixed top-4 right-4 z-50 flex flex-row bg-black text-white rounded-full font-medium text-sm pl-2 pr-3 py-1 items-center gap-1 shadow-lg"
    >
        <PhGear class="w-5 h-5" weight="fill"/>
        Admin
    </a>
</template>

<script setup>
import {computed} from 'vue';
import {usePage} from '@inertiajs/vue3';
import {PhGear} from "@phosphor-icons/vue";

const isAdmin = computed(() => usePage().props.auth.admin);
</script>
